import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const FORM_DEFINITION_FILE_STATE_QUERY = gql`
  query FormDefinitionFileStateQuery($formDefinitionId: StrictString!) @skipAudit @engComponent(name: FORMS) {
    formDefinition(id: $formDefinitionId) {
      ... on FormDefinitionNode {
        id
        name
        editUrl
        archiveRecord {
          __typename
          purpose
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
